import React, { useState } from 'react';
import { PopoverProps, PopoverContentProps } from '@radix-ui/react-popover';
import { Popover, PopoverContent, PopoverTrigger } from '../index';
import { cn } from '../../../../../utils/styles';

interface HoverPopoverProps extends PopoverProps, React.PropsWithChildren {
  label: React.ReactNode;
  align?: PopoverContentProps['align'];
  popoverClassName?: string;
  size?: '35px' | 'auto';
}

function HoverPopover({ label, children, align, popoverClassName, size, ...props }: HoverPopoverProps) {
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <div
      className={cn('flex items-center justify-center', {
        'border border-muted rounded-lg !h-[35px] w-[35px]': size === '35px',
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Popover open={open} {...props}>
        <PopoverTrigger className="focus-visible:none outline-none">{label}</PopoverTrigger>
        <PopoverContent className={cn('mt-[12px]', popoverClassName)} align={align}>
          {children}
        </PopoverContent>
      </Popover>
    </div>
  );
}

HoverPopover.defaultProps = {
  align: 'center',
  popoverClassName: undefined,
  size: '35px',
};

export default HoverPopover;
